const indexItems = [
  { label: '动作大片', icon: 'ri-fire-line', desc: '燃爆肾上腺素' },
  { label: '爱情甜剧', icon: 'ri-heart-line', desc: '甜蜜治愈心灵' },
  { label: '悬疑烧脑', icon: 'ri-search-eye-line', desc: '挑战推理极限' },
  { label: '科幻巨制', icon: 'ri-rocket-line', desc: '探索无限宇宙' },
  { label: '古装经典', icon: 'ri-vip-crown-line', desc: '穿越历史长河' },
  { label: '动漫番剧', icon: 'ri-ghost-smile-line', desc: '二次元盛宴' },
  { label: '纪录纪实', icon: 'ri-earth-line', desc: '看见真实世界' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-900 text-center mb-3">
          分类索引
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-10 md:mb-14 max-w-xl mx-auto">
          按类型快速找到你想看的影视内容
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 md:gap-4">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex flex-col items-center gap-2.5 p-4 md:p-5 rounded-2xl bg-background-100 hover:bg-primary-50/40 cursor-pointer transition-colors duration-200 text-center"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-lg md:text-xl text-primary-600`}></i>
              </div>
              <span className="text-sm font-heading text-foreground-900 whitespace-nowrap">{item.label}</span>
              <span className="text-[10px] md:text-xs text-foreground-400">{item.desc}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}